const FaqCard = (props) => {
  return (
    <li className="faq-card">
      <details name="faq" open>
        <summary className="boldTitle box-shadow">{props.faq}</summary>
        <p className=" font-inter-regular">{props.answer}</p>
      </details>
    </li>
  );
};

export default FaqCard;
